export var isMac = function () { return /Mac/.test(navigator.platform); };
export var isWindows = function () { return /Win/.test(navigator.platform); };
//# sourceMappingURL=platformDetector.js.map